import React from "react";
import {Link} from 'react-router-dom'



function BlogsHome() {
  return (
    <section className="blog-area pt-110 pb-60">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-7 col-lg-9">
          <div className="section-title text-center mb-65">
            <div className="section-icon"><img src="img/icon/pawprint.png" alt="" /></div>
            <h5 className="sub-title">Nos actualités</h5>
            <h2 className="title">Nouveautés</h2>
            <p>SafiDog vous aide à connaître la race et la santé de votre chien</p>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-4 col-md-6">
          <div className="blog-post-item mb-50">
            <div className="blog-post-thumb">
              <Link to="/blog-details"><img src="img/blog/blog_post_thumb01.jpg" alt="" /></Link>
              <div className="blog-post-tag">
                <Link to="/"><i className="flaticon-bookmark-1" />Obéissance</Link>
              </div>
            </div>
            <div className="blog-post-content">
              <div className="blog-post-meta">
                <ul>
                  <li><i className="far fa-user" /><Link to="/">Senegal</Link></li>
                  <li><i className="far fa-bell" /> Safi dog</li>
                </ul>
              </div>
              <h3 className="title"><Link to="blog-details">Safi Dog : la référence de la vente de chiens de race à Tangis (Sénégal)</Link></h3>
              <p>Au Sénégal, l’intérêt pour les chiens de race ne cesse de grandir, que ce soit pour la sécurité, la compagnie ou le sport. Située à Tangis, Safi Dog s’impose aujourd’hui comme une entreprise de confiance spécialisée dans la vente de chiens de race et les services canins complets.</p>
              <Link to="/blog-details" className="read-more">Safidog<img src="img/icon/pawprint.png" alt="" /></Link>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="blog-post-item mb-50">
            <div className="blog-post-thumb">
              <Link to="/blog-details"><img src="img/blog/blog_post_thumb02.jpg" alt="" /></Link>
              <div className="blog-post-tag">
                <Link to="/"><i className="flaticon-bookmark-1" />Protection</Link>
              </div>
            </div>
            <div className="blog-post-content">
              <div className="blog-post-meta">
                <ul>
                  <li><i className="far fa-user" /><Link to="/">Senegal</Link></li>
                  <li><i className="far fa-bell" />Safi Dog</li>
                </ul>
              </div>
              <h3 className="title"><Link to="/blog-details">Dressage, pension et gardiennage : des services canins professionnels avec Safi Dog</Link></h3>
              <p>Posséder un chien implique des responsabilités. C’est pourquoi Safi Dog, entreprise basée à Tangis, accompagne les propriétaires de chiens bien au-delà de la vente.</p>
              <Link to="/blog-details" className="read-more">Safidog<img src="img/icon/pawprint.png" alt="" /></Link>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="blog-post-item mb-50">
            <div className="blog-post-thumb">
              <Link to="/blog-details"><img src="img/blog/blog_post_thumb03.jpg" alt="" /></Link>
              <div className="blog-post-tag">
                <Link to="/"><i className="flaticon-bookmark-1" />Performance</Link>
              </div>
            </div>
            <div className="blog-post-content">
              <div className="blog-post-meta">
                <ul>
                  <li><i className="far fa-user" /><Link to="/">Senegal</Link></li>
                  <li><i className="far fa-bell" /> Safi Dog</li>
                </ul>
              </div>
              <h3 className="title"><Link to="#">Croquettes, accessoires et transport de chiens : Safi Dog, un service tout-en-un à Tangis</Link></h3>
              <p>Pour garantir la santé et le bien-être d’un chien, il est essentiel de lui fournir une bonne alimentation et des équipements adaptés. Chez Safi Dog, nous proposons une large gamme de croquettes de qualité, choisies selon l’âge, la race et l’activité du chien.</p>
              <Link to="#" className="read-more">Safidog<img src="img/icon/pawprint.png" alt="" /></Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  )
}

export default BlogsHome;
